<div class="autocomplete-form-container" id="autocomplete-form-container">
  <form class="autocomplete-form" id="autocomplete-form" [ngClass]="getClassName()">
    <mat-form-field
      id="autocomplete-form-field"
      class="autocomplete-form-field"
      appearance="fill"
    >
      <input
        id="autocomplete-input"
        class="autocomplete-input"
        type="text"
        [placeholder]="placeholder"
        aria-label="Number"
        matInput
        #trigger="matAutocompleteTrigger"
        [formControl]="autocompleteForm"
        (input)="onInputChange($event)"
        [matAutocomplete]="auto"
        (keyup.enter)="onKeyEnter($event); trigger.closePanel()"
      />

      <app-icon
        *ngIf="customError"
        [name]="customIcon"
        class="error-icon"
        id="error-icon"
        size="1.2em"
      ></app-icon>

      <mat-autocomplete
        id="autocomplete"
        #auto="matAutocomplete"
        (optionSelected)="onSelectionChange($event)"
        [displayWith]="displayMatAutoData"
      >
        <mat-option
          [id]="'autocomplete-option-' + option?.id"
          class="autocomplete-options"
          *ngFor="let option of options"
          [value]="option"
        >
          <div id="shared-autocomplete-option-content" class="option-content">
            <app-text
              id="shared-autocomplete-option-content-label"
              [textStyleType]="'body1'"
            >
              {{ option?.name }}
            </app-text>

            <app-icon
              *ngIf="option?.showIcon"
              [id]="'autocomplete-option-content-icon' + option?.id"
              [name]="option?.iconName!"
              [class]="option?.iconClass!"
              [size]="option?.iconSize!"
            ></app-icon>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-error *ngIf="customError" id="autocomplete-error" class="autocomplete-error">
      <app-text [textStyleType]="'mobile-overline'" id="autocomplete-error-text">{{
        customErrorMessage
      }}</app-text>
    </mat-error>
  </form>
</div>
